module.exports = __webpack_public_path__ + "static/img/14000070.8636962d.png";